import React, {useCallback, useMemo, useState} from 'react';

import {useLayoutTypes} from 'src/hooks/dictionaries/useLayoutDictionaries';
import {COLUMN_WIDTHS, SCOPE_KEY} from 'src/modules/profile/user/tabs/content/layouts/util';
import {UserLayoutRequestSortBy} from 'src/openapi/admin/models/UserLayoutRequest';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {SortHeaderFilter} from '@pb/kit-component-filters';
import Label from '@pb/kit-component-label';
import {Cell} from '@pb/kit-component-table';

import {apiToUiSort, uiToApiSort} from '../../utils/util';
import {useLayoutCriteria} from '../hooks/useLayoutCriteria';

export const EntityTypeHeader = () => {
    const {criteria, setSort, setCriteria} = useLayoutCriteria(SCOPE_KEY);
    const {layoutTypes, getLayoutTypeByCode} = useLayoutTypes();
    const initialState = useMemo(() => ({entityTypes: undefined as string[] | undefined}), []);
    const [request, setRequest] = useState(initialState);

    const direction =
        criteria?.sortBy === UserLayoutRequestSortBy.ENTITY_TYPE
            ? apiToUiSort(criteria.sortDirection)
            : undefined;

    const currentValue = criteria?.entityTypes?.[0] ?? request.entityTypes?.[0] ?? undefined;

    const onCancel = useCallback(() => (
        setRequest(criteria?.entityTypes?.length
            ? {entityTypes: criteria.entityTypes}
            : initialState)
    ), [criteria?.entityTypes, initialState]);

    return (
        <Cell width={COLUMN_WIDTHS.ENTITY_TYPE} className="nowrap">
            <SortHeaderFilter
                caption="Entity Type"
                filterActive={!!criteria?.entityTypes?.length}
                sortable={true}
                direction={direction}
                defaultDirection="ASC"
                onSort={dir => setSort(UserLayoutRequestSortBy.ENTITY_TYPE, uiToApiSort(dir))}
                onReset={() => {
                    setRequest(initialState);
                    setCriteria({entityTypes: undefined});
                }}
                onCancel={onCancel}
                onApply={() => {
                    setCriteria(request);
                }}>
                <div>
                    <Label>Entity Type</Label>
                    <ComboBox<string, string>
                        value={currentValue}
                        onChange={val => setRequest({entityTypes: val ? [val] : undefined})}
                        placeholder="Select Entity Type">
                        {layoutTypes.map(item => (
                            <ComboboxItem
                                key={item.code}
                                caption={getLayoutTypeByCode(item.code)?.description || item.code}
                                value={item.code}
                            />
                        ))}
                    </ComboBox>
                </div>
            </SortHeaderFilter>
        </Cell>
    );
};
